import type { VerifyAccountState, VerifyAccountStore } from '../domain/verifyAccountTypes'
import { createStore } from 'zustand'

export function createVerifyAccountStore(initialState: VerifyAccountState = { status: 'idle' }) {
  return createStore<VerifyAccountStore>(set => ({
    ...initialState,
    setIn: (key, value) => set(state => ({ ...state, [key]: value })),
  }))
}
